// The What's New modal is an announcement of the new service-line pages and
// the sidebar restructure. It should only be shown to households that existed
// BEFORE the feature launched — new clients onboarding after this date never
// experienced the prior nav, so the modal would be confusing rather than
// helpful.
//
// Stored as midnight America/New_York on launch day. May is EDT (UTC-4), so
// 04:00 UTC == 00:00 EDT. Update the date portion to the actual production
// launch day once finalized; keep the 04:00:00Z offset for EDT, or switch to
// 05:00:00Z if launch lands in EST (Nov–Mar).
export const SERVICE_LINES_LAUNCH_DATE = new Date("2026-05-20T04:00:00Z");
